/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import { Button } from "devextreme-react/button";
import Toolbar, { Item } from "devextreme-react/toolbar";
import LoadPanel from "devextreme-react/load-panel";
import { formatMessage } from "devextreme/localization";
import { useDispatch, useSelector } from "react-redux";
import notify from "devextreme/ui/notify";
import UsingIntl from "../../../services/using_intl";
import { axios, getParentPath } from "../../../common";
import { useScreenSize } from "../../../utils/media-query";
import {
  IsPermisionPathRequired,
  showShift,
  getEmployeeByDeclarant,
} from "../../../redux/actions";
import {
  responseMiddleware,
  responseShift,
  responseEmployee,
} from "../../../redux/reducers";
import { getHmmss } from "../../../services/overtime";
import { useAuth } from "../../../contexts/auth";
import { validateNullOrEmpty } from "../../../middlewares/validate";
import "./style.scss";

import FormComponent from "./FormComponent";
import EarlyLate from "./EarlyLate";

export default function OvertimeRegistrationCreate() {
  const history = useHistory();
  const { user } = useAuth();
  const formData = useRef({
    // TotalHours: 0,
    IsBeforeShift: false,
    TotalHours: 0,
  });
  const dispatch = useDispatch();
  const { isXSmall, isSmall } = useScreenSize();
  const { middlewarePath: middleware, loading } =
    useSelector(responseMiddleware);
  const { shift } = useSelector(responseShift);
  const { employeesDeclarant } = useSelector(responseEmployee);
  const [shiftTimeIn, setShiftTimeIn] = useState();
  const [shiftTimeOut, setShiftTimeOut] = useState();
  const [isDisableShift, setIsDisableShift] = useState(false);
  const PARENT_PATH = getParentPath();


  useEffect(() => {
    UsingIntl("P0023");
    dispatch(IsPermisionPathRequired(PARENT_PATH));
  }, [dispatch]);

  useEffect(() => {
    if (middleware) {
      const { NavigateState, CreateState, ReadState } = middleware;
      if (
        (NavigateState !== undefined && !NavigateState) ||
        (ReadState !== undefined && !ReadState) ||
        (CreateState !== undefined && !CreateState)
      ) {
        history.push("/403");
        return;
      }
      dispatch(getEmployeeByDeclarant(user?.EmployeeOid));
      dispatch(showShift());
    }
  }, [middleware]);

  const handleCallApi = async (payload) => {
    try {
      const { data } = await axios.post("OvertimeRegistration", payload, {
        headers: {
          MappedState: 1,
        },
      });

      // const error = SplitErrorCode(data.value);
      // console.log(error);
      if (!data) {
        notify("Registration has not been saved", "error", 3000);
        return;
      }
      notify("Registration has been saved", "success", 3000);
      history.push("/overtime/overtime-registration/list");
    } catch (error) {
      notify(error.response.data.message, error.response.data.msgType, 3000);
    }
  };

  const handleSaveRegistration = async (e) => {
    const {
      Shift,
      OvertimeDate,
      TimeIn,
      TimeOut,
      TotalHours,
      Reason,
      IsBeforeShift,
      IsBreakTime
    } = formData.current;

    if (TotalHours <= 0) {
      notify("Total hours must be greater than zero", "error", 3000);
      return;
    }
    const payload = {
      Employee: {
        Oid: user?.EmployeeOid,
      },
      Shift: {
        Oid: Shift?.Oid,
      },
      OvertimeDate,
      TimeIn,
      TimeOut,
      TotalHours,
      Reason,
      IsBeforeShift,
      IsApproval: false,
      Register: {
        Oid: user.EmployeeOid,
      },
      IsBreakTime
    };

    if (TotalHours < 0.5) {
      notify("Tổng giờ phải lớn hơn bằng 0.5", "error", 3000);
      return;
    }
    if (typeof TimeIn === "number") {
      payload.TimeIn = getHmmss(new Date(TimeIn));
      formData.current.TimeIn = getHmmss(new Date(TimeIn));
    } else {
      payload.TimeIn = getHmmss(TimeIn);
      formData.current.TimeIn = getHmmss(TimeIn);
    }
    if (typeof TimeOut === "number") {
      payload.TimeOut = getHmmss(new Date(TimeOut));
      formData.current.TimeOut = getHmmss(new Date(TimeOut));
    } else {
      payload.TimeOut = getHmmss(TimeOut);
      formData.current.TimeOut = getHmmss(TimeOut);
    }

    const isNull = validateNullOrEmpty(payload);
    if (isNull) {
      notify("Please fill all fields", "warning", 3000);
      return;
    }
    try {
      const { data } = await axios.post("ValidateTotalHours", payload, {
        headers: {
          MappedState: 1,
        },
      });
      if (data) {
        // eslint-disable-next-line no-restricted-globals
        if (confirm(data.message)) {
          handleCallApi(payload);
        }
      } else {
        handleCallApi(payload);
      }
    } catch (error) {
      notify(error.response.data.message, error.response.data.msgType, 3000);
    }
  };

  return (
    <>
      <LoadPanel visible={loading} />
      {/* Breadcrumb */}
      <div className={"breadcrumb"}>
        <div className={"breadcrumb-left"}>
          <div className={"breadcrumb-page-title"}>
            {formatMessage("OvertimeRegistrationCreate")}
          </div>
        </div>
        <div className={"breadcrumb-right"}>
          <Link to="/overtime-registration/list" className={"breadcrumb-item"}>
            {formatMessage("Overtime")}
          </Link>
          <span className={"breadcrumb-item active"}>
            {formatMessage("OvertimeRegistration")}
          </span>
        </div>
      </div>

      <div className={"section"}>
        <div className={"section-heading has-page-title"}>
          <h4 className={"page-title"}>
            {user?.EmployeeCode + " - " + user?.EmployeeName}
          </h4>
          <div className={`page-actions`}>
            <Toolbar>
              <Item
                location="after"
                locateInMenu={isXSmall || isSmall ? "always" : "auto"}
                cssClass={"datagrid-toolbar-actions-dropdown"}
              >
                <Button
                  icon="check"
                  text={formatMessage("Save")}
                  onClick={handleSaveRegistration}
                  type="default"
                  stylingMode="outlined"
                  className="mr-2"
                />
                <Button
                  icon="close"
                  text={formatMessage("Cancel")}
                  onClick={() =>
                    history.push("/overtime/overtime-registration/list")
                  }
                />
              </Item>
            </Toolbar>
          </div>
        </div>
        <div className={"section-body"}>
          <FormComponent
            formData={formData}
            shift={shift}
            setShiftTimeIn={setShiftTimeIn}
            setShiftTimeOut={setShiftTimeOut}
            employee={employeesDeclarant}
            employeeOid={user?.EmployeeOid}
            isDisableShift={isDisableShift}
          />
          <EarlyLate
            formData={formData}
            shiftTimeIn={shiftTimeIn}
            shiftTimeOut={shiftTimeOut}
          />
        </div>
      </div>
    </>
  );
}
